<script setup lang="ts">
import { onMounted, watch } from 'vue'
import { useAuth } from './composables/useAuth'
import { useInactivityTracker } from './composables/useInactivityTracker'
import LoadingScreen from './components/ui/loading/LoadingScreen.vue'
import RoundupNotification from './components/notifications/RoundupNotification.vue'
import InactivityWarning from './components/notifications/InactivityWarning.vue'
import { RouterView } from 'vue-router'
import { TooltipProvider } from '@/components/ui/tooltip'

const { loading, initAuth, user } = useAuth()
const { startTracking } = useInactivityTracker()

onMounted(() => {
  initAuth()
})

// Start tracking inactivity when user is logged in
watch(
  () => user.value,
  (newUser) => {
    if (newUser) {
      // Start tracking user activity when logged in
      const cleanup = startTracking()

      // Return cleanup function to stop tracking when user logs out
      return cleanup
    }
  },
  { immediate: true },
)
</script>

<template>
  <TooltipProvider>
    <LoadingScreen v-if="loading" />
    <template v-else>
      <RouterView />
      <RoundupNotification />
      <InactivityWarning />
    </template>
  </TooltipProvider>
</template>
